import { render, staticRenderFns } from "./readLetter.vue?vue&type=template&id=45c8bae6&"
import script from "./readLetter.vue?vue&type=script&lang=js&"
export * from "./readLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports